import React from "react";

function Conditions() {
  return (
    <div>
        <h2>GDPR-verklaring voor het verzamelen van persoonsgegevens</h2>
        <h3 className="mt-2">Inleiding</h3>
        <p className="ptb-1">
          Bij StuPu hechten we veel waarde aan de bescherming van uw
          persoonsgegevens. Deze verklaring legt uit hoe wij uw gegevens
          verzamelen, gebruiken en beschermen in overeenstemming met de Algemene
          Verordening Gegevensbescherming (GDPR).
        </p>
        <h3 className="mt-1">Doel van gegevensverwerking</h3>
        <p className="ptb-1">Wij verzamelen uw persoonsgegevens voor de volgende doeleinden:</p>
        <ul className="p-1">
          <li className="medium">Om u in te schrijven als bijlesgever via ons platform.</li>
          <li className="medium">Om u toegang te geven tot uw account en studentencontracten.</li>
          <li className="medium">
            Om contact met u op te nemen over belangrijke informatie met
            betrekking tot uw bijlesactiviteiten.
          </li>
          <li className="medium">Voor administratieve en organisatorische doeleinden.</li>
        </ul>
        <h3 className="mt-1">Verzamelde persoonsgegevens</h3>
        <p className="ptb-1">De persoonsgegevens die wij van u verzamelen kunnen omvatten:</p>
        <ul className="p-1">
          <li className="medium">Voornaam en achternaam</li>
          <li className="medium">Geboorteplaats & datum </li>
          <li className="medium">E-mailadres </li>
          <li className="medium">Telefoonnummer </li>
          <li className="medium">Adres </li>
          <li className="medium">Opleidingsgegevens </li>
        </ul>
        <h3 className="mt-1">Rechtsgrond voor verwerking</h3>
        <p className="ptb-1">
          Wij verwerken uw persoonsgegevens op basis van uw toestemming, die u
          kunt intrekken wanneer u maar wilt, en op basis van de uitvoering van de
          overeenkomst die wij met u aangaan.
        </p>
        <h3 className="mt-1">Bewaartermijn</h3>
        <p className="ptb-1">
          Uw persoonsgegevens worden niet langer bewaard dan noodzakelijk is voor
          de doeleinden waarvoor ze zijn verzameld, met inachtneming van
          wettelijke verplichtingen.
        </p>
        <h3 className="mt-1">Beveiliging van gegevens</h3>
        <p className="ptb-1">
          Wij nemen passende technische en organisatorische maatregelen om uw
          persoonsgegevens te beschermen tegen verlies, diefstal of ongeoorloofde
          toegang.
        </p>
        <h3 className="mt-1">Rechten van betrokkenen</h3>
        <ul className="p-1">
          <li className="medium">Inzage te vragen in uw persoonsgegevens.</li>
          <li className="medium">Correctie of verwijdering van uw persoonsgegevens te verzoeken.</li>
          <li className="medium">Beperking van de verwerking te vragen.</li>
          <li className="medium">Uw gegevens over te dragen.</li>
          <li className="medium">Tegen de verwerking van uw gegevens bezwaar te maken.</li>
        </ul>

        <h3 className="mt-1">Contact</h3>
        <p className="ptb-1">
          Als u vragen heeft over deze GDPR-verklaring of uw persoonsgegevens,
          kunt u contact met ons opnemen via:
        </p>
        <ul>
          <li className="medium">E-mailadres:<a href="mailto:noud@stupu.be">noud@stupu.be</a></li>
          <li className="medium">Telefoonnummer: <a href="tel:+32 473 82 03 18">+32 473 82 03 18</a></li>
        </ul>
        <h3 className="mt-1">Wijzigingen in deze verklaring</h3>
        <p className="ptb-1">
          Wij behouden ons het recht voor om deze verklaring te wijzigen. Wij
          adviseren u om deze verklaring regelmatig te raadplegen.
        </p>      
    </div>

  );
}

export default Conditions;
